/**
 * Functionality to rename a Decoder.
 *
 * Meant to be used e.g. on the DecoderDetail page.
 *
 * Depends on:
 *   - this.decoder
 *   - this.decoder.store.id
 *   - Having a dialog with an input with ref="decoderDescriptionInput"
 */
const renameDecoder = {
  data() {
    const vm = this;
    return {
      renaming: false,
      showRenameDecoderDialog: false,

      storeDecoderDescriptions: [],
      newDecoderDescription: '',

      decoderDescriptionMinimum: 3,
      decoderDescriptionMaximum: 64,
      decoderDescriptionRules: {
        min: (v) =>
          (!!v && v.trim().length >= vm.decoderDescriptionMinimum) ||
          vm.$t('tooShort'),
        max: (v) =>
          !v || v.length <= vm.decoderDescriptionMaximum || vm.$t('tooLong'),
        unique: (v) => {
          // No changes? That's handled later on, accept value here.
          if (v === vm.decoder.description) {
            return true;
          }
          return (
            vm.isNewDescriptionUniqueForStore(v) ||
            vm.$t('decoderNameAlreadyInUseInStore')
          );
        },
      },
    };
  },
  computed: {
    renameFormIsValid() {
      const hasChanged =
        this.newDecoderDescription !== this.decoder.description;
      const validLength =
        this.newDecoderDescription.length >= this.decoderDescriptionMinimum &&
        this.newDecoderDescription.length <= this.decoderDescriptionMaximum;
      const unique = this.isNewDescriptionUniqueForStore(
        this.newDecoderDescription
      );
      return hasChanged && validLength && unique;
    },
  },
  methods: {
    isNewDescriptionUniqueForStore(description) {
      return this.storeDecoderDescriptions.indexOf(description) == -1;
    },
    fetchStoreDecoderDescriptions() {
      const storeId = this.decoder.store.id;
      this.$api.getStoreDecoderDescriptions(storeId).then((response) => {
        this.storeDecoderDescriptions = response.data;
      });
    },
    startRenamingDecoder() {
      this.fetchStoreDecoderDescriptions();
      this.newDecoderDescription = this.decoder.description;

      this.showRenameDecoderDialog = true;

      this.$nextTick(() => {
        this.$refs.decoderDescriptionInput.focus();
      });
    },
    abortRenamingDecoder() {
      this.showRenameDecoderDialog = false;

      this.storeDecoderDescriptions = [];
      this.newDecoderDescription = '';
    },
    updateDecoderDescription(
      ctype,
      decoderId,
      newDescription,
      successCallback
    ) {
      this.renaming = true;
      this.$api
        .renameDecoder(ctype, decoderId, newDescription)
        .then((response) => {
          this.abortRenamingDecoder();
          successCallback();

          // Since we cache sites, make sure the next visit to the
          // Sites page will fetch the renamed Decoder.
          this.$store.commit('RESET_SITES');
        })
        .catch((error) => {
          this.$bus.$emit('alert-error', {
            message: 'genericFailFeedback',
            translate: true,
          });
        })
        .finally(() => {
          this.renaming = false;
        });
    },
  },
};

export default renameDecoder;



// WEBPACK FOOTER //
// ./src/mixins/renameDecoder.js